import React, { useState, useEffect, useRef } from 'react';
import { useAuth } from '../context/AuthContext';
import { apiFetch } from '../services/api';
import { FaArrowLeft, FaPaperPlane } from 'react-icons/fa';

export default function ReportThread({ reportId, onBack }) {
  const { token, user } = useAuth();
  const [report, setReport] = useState(null);
  const [mensajes, setMensajes] = useState([]);
  const [text, setText] = useState('');
  const [sending, setSending] = useState(false);
  const bottomRef = useRef();

  const cargarReporte = () => {
    apiFetch(`/reports/${reportId}`, {}, token)
      .then(setReport).catch(() => {});
  };

  const cargarMensajes = () => {
    apiFetch(`/reports/${reportId}/messages`, {}, token)
      .then(setMensajes).catch(() => {});
  };

  useEffect(() => {
    cargarReporte();
    cargarMensajes();
    const interval = setInterval(cargarMensajes, 5000);
    return () => clearInterval(interval);
  }, [reportId, token]);

  useEffect(() => {
    bottomRef.current?.scrollIntoView({ behavior: 'smooth' });
  }, [mensajes]);

  const handleSend = async () => {
    if (!text.trim()) return;
    setSending(true);
    try {
      const msg = await apiFetch(`/reports/${reportId}/messages`, {
        method: 'POST',
        body: JSON.stringify({ text })
      }, token);
      setMensajes(prev => [...prev, msg]);
      setText('');
    } catch {}
    setSending(false);
  };

  const handleKeyDown = (e) => {
    if (e.key === 'Enter' && !e.shiftKey) { e.preventDefault(); handleSend(); }
  };

  return (
    <div style={{position:'fixed', top:0, left:0, width:'100%', height:'100dvh',
      backgroundColor:'#111318', display:'flex', flexDirection:'column'}}>

      {/* Header */}
      <div style={{backgroundColor:'#1a1d24', borderBottom:'1px solid #2a2d35',
        padding:'12px 16px', display:'flex', alignItems:'center', gap:'12px', flexShrink:0}}>
        <button onClick={onBack}
          style={{backgroundColor:'#111318', color:'#9ca3af', padding:'8px',
            border:'1px solid #2a2d35', borderRadius:'10px', display:'flex', cursor:'pointer'}}>
          <FaArrowLeft style={{fontSize:'13px'}} />
        </button>
        <div>
          <p className="text-white font-semibold text-sm">Tu reporte</p>
          <p style={{color:'#f97316', fontSize:'11px'}}>Conversación con el equipo de SenDViGo</p>
        </div>
      </div>

      {/* Contexto del reporte */}
      {report && (
        <div style={{padding:'14px 16px', borderBottom:'1px solid #1e2028', flexShrink:0}}>
          <div style={{display:'flex', gap:'8px', marginBottom:'8px', flexWrap:'wrap'}}>
            <span style={{backgroundColor:'#f8717115', border:'1px solid #f8717130', color:'#f87171',
              fontSize:'11px', fontWeight:'600', padding:'3px 10px', borderRadius:'20px'}}>
              {report.categoria}
            </span>
            <span style={{
              backgroundColor: report.estado === 'resuelto' ? '#22c55e15' : '#f59e0b15',
              border: `1px solid ${report.estado === 'resuelto' ? '#22c55e30' : '#f59e0b30'}`,
              color: report.estado === 'resuelto' ? '#4ade80' : '#f59e0b',
              fontSize:'10px', fontWeight:'600', padding:'3px 8px', borderRadius:'20px'}}>
              {report.estado === 'resuelto' ? '✓ Resuelto' : '⏳ Pendiente'}
            </span>
          </div>
          <p style={{color:'#9ca3af', fontSize:'12px', marginBottom:'2px'}}>
            Sobre: <span style={{color:'white', fontWeight:'600'}}>{report.toUser?.name}</span>
          </p>
          <p style={{color:'#6b7280', fontSize:'12px', marginBottom:'6px'}}>{report.subcategoria}</p>
          {report.detalle && (
            <p style={{color:'#9ca3af', fontSize:'12px', fontStyle:'italic', marginBottom:'8px'}}>"{report.detalle}"</p>
          )}
          {report.package && (
            <p style={{color:'#3b82f6', fontSize:'11px', marginBottom:'8px'}}>
              📦 Envío vinculado: {report.package.from} → {report.package.to}
            </p>
          )}
          {report.capturaUrl && (
            <a href={report.capturaUrl} target="_blank" rel="noopener noreferrer">
              <img src={report.capturaUrl} alt="Captura adjunta" style={{
                maxWidth:'160px', maxHeight:'120px', borderRadius:'10px', border:'1px solid #2a2d35',
              }} />
            </a>
          )}
        </div>
      )}

      {/* Mensajes */}
      <div style={{flex:1, overflowY:'auto', padding:'16px 12px',
        display:'flex', flexDirection:'column', gap:'10px'}}>

        {mensajes.length === 0 && (
          <div className="text-center" style={{paddingTop:'60px'}}>
            <div style={{fontSize:'40px', opacity:0.15}} className="mb-3">🚨</div>
            <p style={{color:'#6b7280', fontSize:'13px'}}>Aún no hay respuesta</p>
            <p style={{color:'#3a3d45', fontSize:'11px', marginTop:'4px'}}>
              Revisaremos tu reporte lo antes posible
            </p>
          </div>
        )}

        {mensajes.map(m => {
          const esAdmin = m.user?.role === 'admin';
          const esMio = m.userId === user?.id;
          return (
            <div key={m.id} style={{display:'flex', flexDirection: esMio ? 'row-reverse' : 'row', gap:'8px'}}>
              <div style={{maxWidth:'78%'}}>
                {esAdmin && !esMio && (
                  <p style={{color:'#f97316', fontSize:'10px', fontWeight:'700', marginBottom:'4px', marginLeft:'4px'}}>
                    🛡️ Equipo SenDViGo
                  </p>
                )}
                <div style={{
                  padding:'10px 14px', borderRadius: esMio ? '16px 16px 4px 16px' : '16px 16px 16px 4px',
                  backgroundColor: esMio ? '#f97316' : (esAdmin ? '#f9731615' : '#1a1d24'),
                  border: esMio ? 'none' : `1px solid ${esAdmin ? '#f9731630' : '#2a2d35'}`,
                }}>
                  <p style={{fontSize:'14px', color: esMio ? 'white' : '#e5e7eb', lineHeight:'1.5', wordBreak:'break-word'}}>
                    {m.text}
                  </p>
                </div>
                <p style={{fontSize:'10px', color:'#3a3d45', marginTop:'3px', textAlign: esMio ? 'right' : 'left'}}>
                  {new Date(m.createdAt).toLocaleTimeString('es-ES', {hour:'2-digit', minute:'2-digit'})}
                </p>
              </div>
            </div>
          );
        })}
        <div ref={bottomRef} />
      </div>

      {/* Input */}
      <div style={{backgroundColor:'#1a1d24', borderTop:'1px solid #2a2d35',
        padding:'12px 16px', flexShrink:0}}>
        <div style={{display:'flex', alignItems:'center', gap:'8px'}}>
          <input
            value={text}
            onChange={e => setText(e.target.value)}
            onKeyDown={handleKeyDown}
            placeholder="Escribe tu respuesta..."
            style={{flex:1, minWidth:0, backgroundColor:'#111318', border:'1px solid #2a2d35',
              color:'white', borderRadius:'20px', padding:'10px 16px', fontSize:'14px'}}
            className="focus:outline-none focus:ring-1 focus:ring-orange-500 placeholder-gray-600"
          />
          <button onClick={handleSend}
            disabled={sending || !text.trim()}
            style={{backgroundColor: text.trim() ? '#f97316' : '#2a2d35',
              color:'white', borderRadius:'50%', width:'40px', height:'40px',
              display:'flex', alignItems:'center', justifyContent:'center',
              flexShrink:0, opacity: sending ? 0.5 : 1, cursor: text.trim() ? 'pointer' : 'default'}}>
            <FaPaperPlane style={{fontSize:'13px'}} />
          </button>
        </div>
      </div>
    </div>
  );
}